<template>
  <div class="member-auth">
    <div class="common-header-wrap">
      <mt-header title="保险购买" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="form">
      <mt-field class="menu-item" label="姓名：" v-model="member_info.member_truename" />
      <mt-field class="menu-item" label="身份证号：" v-model="member_info.member_idcard" />
      <mt-field class="menu-item" label="电话号码：" v-model="member_info.member_mobile" />
      <mt-field class="menu-item" label="缴费账号：" :attr="{ maxlength: 9 }" v-model="member_info.member_number" />
      <mt-field class="menu-item" label="备注：" v-model="descript" type="textarea" rows="2"/>
      <mt-button class="ds-button-large mb-10" type="primary" @click="confirmSumit">确定并支付</mt-button>
    </div>
  </div>
</template>
<script>
  import { Toast  } from 'mint-ui'
  import { getPaymentList } from '../../../api/memberPayment'
  import { loadScript } from '../../../util/common'
  import { getInsuranceBuy ,insurancePay} from '../../../api/member'
  import { mapState, mapMutations } from 'vuex'
  import {  updateMemberInfoV2 } from '../../../api/member'

  export default {
    components: {
    },
    name: 'MemberProfileSet',
    data () {
      return {
        status: -1,
        descript: '',
        insurance_id: 0,
        pay_sn:  '',
        pay_price:  0,
        pay_type: 'pay_insurance',
        // 订单支付显示的数据
        pay_info: null,
        // 提交支付需要用到的数据
        payment_info: {
          password: '', // 支付密码
          rcb_pay: 0, // 是否使用充值卡进行支付
          pd_pay: 0, // 是否使用预存款进行支付
          payment_code: 'alipay_h5', // 支付方式

        },
        member_info: {
          member_truename: '',
          member_idcard: '',
          member_mobile: '',
          member_number: ''
        }
      }
    },
    mounted () {
    },
    computed: {
      ...mapState({
        user: state => state.member.info,
        token: state => state.member.token
      })
    },
    created: function () {
      this.insurance_id = this.$route.query.id;
      this.status = this.$route.query.status;
      if (this.user) {
        this.member_info.member_truename = this.user.member_truename
        this.member_info.member_idcard = this.user.member_idcard
        this.member_info.member_mobile = this.user.member_mobile
        this.member_info.member_number = this.user.member_number
      }
      this.getPaymentList()
    },
    methods: {
      ...mapMutations({
        memberEdit: 'memberEdit'
      }),
      confirmSumit () {
        updateMemberInfoV2(this.member_info).then(res => {
          this.memberEdit(this.member_info)
          getInsuranceBuy(this.insurance_id,this.status,this.descript).then(res => {
            this.pay_price = res.result.price
            this.pay_sn = res.result.order
            if (this.payment_info.payment_code == 'wxpay_minipro') {
              wx.miniProgram.redirectTo({ url: '../pay/pay?action=' + this.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code })
              return
            }
            insurancePay(
                    this.pay_sn, this.pay_type, this.payment_info, this.token
            ).then((res) => {
              if (res.code) {
                if (res.code === 10000) {

                } else {
                  Toast(res.message)
                }
              } else {
                document.write(res)
              }
            }).catch(function (error) {
              if (error.message) {
                Toast(error.message)
              } else {
                document.write(error)
              }
            })
          }).catch(function (error) {
            Toast(error.message)
          });

        }).catch(function (error) {
          Toast(error.message)
        })
      },
      getPaymentList(){
        let _this = this
        getPaymentList().then(res=>{
          this.payment_list=res.result.payment_list
          if (this.payment_list.length) {
            this.payment_info.payment_code = this.payment_list[0].payment_code
          }
          loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
            wx.miniProgram.getEnv(function (res) {
              for(var i in _this.payment_list){
                if (res.miniprogram) {
                  if(_this.payment_list[i].payment_code=='wxpay_jsapi'){
                    _this.payment_list.splice(i,1)
                    break
                  }
                }else{
                  if(_this.payment_list[i].payment_code=='wxpay_minipro'){
                    _this.payment_list.splice(i,1)
                    break
                  }
                }
              }
            })
          })
        }).catch(function(error){
          Toast(error.message)
        })
      },
    }
  }
</script>
<style  lang="scss" scoped>
  .member-auth {
    background: #fff;
    .idcard-wrapper{
      padding: .5rem 5% ;
      background: #f5f5f5;
      .idcard-item{
        background: #fff;
        padding: 1rem 0;
        margin-bottom:.5rem;
        .del-btn{
          position: absolute;
          font-size: 1.5rem;
          top: -.75rem;
          right: -.75rem;
        }
        .title{
          font-size: .8rem;
          text-align: center;
          margin-top:.5rem;
        }
      }
    }
    .user-avatar {
      display: block;
      position: relative;
      width: 10rem;
      height: 8rem;
      margin: 0 auto;
      text-align: center;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 8rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
  }
</style>
<style>
  .member-auth .mint-cell-title{flex:unset;width:7rem}
  .member-auth .mint-cell-value{flex:1}
</style>
